// extracted by mini-css-extract-plugin
export default {"bgVideoWrapper":"StartBgVideo_bgVideoWrapper__oT5Gf","unvisible":"StartBgVideo_unvisible__XYG-f"};